import { LitElement, css, html } from "lit"
import { unsafeHTML } from "lit/directives/unsafe-html.js"
import { when } from "lit/directives/when.js"
import { styles } from "../styles/single"
const { apiFetch } = window.wp

export class Single extends LitElement {
	static get properties() {
		return {
			id: { type: Number },
			post: { type: Object, state: true },
			loading: { type: Boolean, state: true },
			ImageData: { type: Object, state: true },
			rowCount: { type: Number },
			columnCount: { type: Number },
		}
	}

	static get styles() {
		return styles
	}

	constructor() {
		super()
		this.post = {}
		this.loading = true
		this.ImageData = null
	}
	updated(changedProperties) {
		super.updated(changedProperties) // Call the super method
		if (changedProperties.has("post") && this.post.id) {
			this.loading = true

			//get media from post.featured_media_url
			this.loadMedia(this.post.featured_media)
				.then(media => {
					this.ImageData = media
					this.loading = false
				})
				.catch(error => {
					console.error("Failed to load media:", error)
					this.loading = false
				})
		}
	}

	async loadMedia(id) {
		return apiFetch({
			path: `/wp/v2/media/${id}`,
			method: "GET",
		})
			.then(response => {
				return response // Return the fetched media response
			})
			.catch(error => {
				throw error // Rethrow the error to be caught in the caller
			})
	}

	renderNoImage() {
		return html`
			<a href="${this.post.link}">
				<div class="no-image"></div>
				<div class="entry">
					<h2>${this.post.title.rendered}</h2>
				</div>
			</a>
		`
	}

	renderWithImage() {
		return html`
			<div class="img-container ">
				<img
					src="${this.ImageData.source_url}"
					alt="${this.ImageData.alt_text}" />
			</div>
			<div class="content-container">
				<h2>${unsafeHTML(this.post.title.rendered)}</h2>
				<p>${unsafeHTML(this.post.excerpt.rendered)}</p>
				<a href="${this.post.link}">Läs mer</a>
			</div>
		`
	}

	render() {
		if (this.loading) return html`<div class="loading"></div>`
    let className = `single-post ${this.id % 4 === 3 ? "full-post" : ""}`
		return html`
			<div class="${className}">
				${when(
					this.ImageData,
					() => this.renderWithImage(),
					() => this.renderNoImage()
				)}
			</div>
		`
	}
}
